import React, { Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import LoadingFallback from "./pages/loading/loading-state";
import GeneralError from "./pages/errors/general-error";
import NotFoundError from "./pages/errors/not-found-error";
import MaintenanceError from "./pages/errors/maintenance-error";
import UnauthorisedError from "./pages/errors/unauthorised-error";
import PrivacyPolicy from "./pages/privacy/privacy";

import TnC from "./pages/privacy/tnc";

const SignIn = React.lazy(() => import("./pages/auth/sign-in"));
const Otp = React.lazy(() => import("./pages/auth/otp"));
const AppShell = React.lazy(() => import("./components/app-shell"));
const Dashboard = React.lazy(() => import("./pages/dashboard/index"));
const Trips = React.lazy(() => import("./pages/trips"));
const Clients = React.lazy(() => import("./pages/clients"));
// const Vehicles = React.lazy(() => import("./pages/vehicles"));
const Settings = React.lazy(() => import("./pages/settings"));
const Profile = React.lazy(() => import("./pages/profile"));
const Finances = React.lazy(() => import("./pages/finances"));
const Ledger = React.lazy(() => import("./pages/ledger"));

const router = createBrowserRouter([
  // Auth routes
  {
    path: "/sign-in",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <SignIn />
      </Suspense>
    ),
  },
  {
    path: "/otp",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Otp />
      </Suspense>
    ),
  },

  // Main routes
  {
    path: "/",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <AppShell />
      </Suspense>
    ),
    errorElement: <GeneralError />,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <Dashboard />
          </Suspense>
        ),
      },
      {
        path: "trips",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <Trips />
          </Suspense>
        ),
      },
      {
        path: "ledger",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <Ledger />
          </Suspense>
        ),
      },
      {
        path: "clients",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <Clients />
          </Suspense>
        ),
        errorElement: <GeneralError />
      },
      {
        path: "finances",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <Finances />
          </Suspense>
        ),
      },
      {
        path: "settings",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <Settings />
          </Suspense>
        ),
      },
      {
        path: "profile",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <Profile />
          </Suspense>
        ),
      },
    ],
  },

  // Error routes
  { path: "/500", element: <GeneralError /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/tnc", element: <TnC /> },
  { path: "/404", element: <NotFoundError /> },
  { path: "/503", element: <MaintenanceError /> },
  { path: "/401", element: <UnauthorisedError /> },

  // Fallback 404 route
  { path: "*", element: <NotFoundError /> },
]);

export default router;
